import Vue from 'vue'
import Vuex from 'vuex'
import { firestore } from '../firebase'

const freelanceRequests = firestore.collection('freelanceRequests')

Vue.use(Vuex)

const state = {
  contacted: false
}

const mutations = {
  SET_CONTACTED: (contacted) => {
    state.contacted = contacted
  }
}

const actions = {
  submitContactForm ({ commit }, { email }) {
    freelanceRequests.doc().set({ email, sent: new Date() })
      .then(() => commit('SET_CONTACTED', true))
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js